module.exports = __webpack_public_path__ + "images/bg-10.376474dff1ce99fe4c7508866a73aa2d.jpg";